export var listen = function listen() {
  window.addEventListener('keydown', function (e) {
    var identifier = [e.altKey ? 'Alt' : null, e.ctrlKey ? 'Control' : null, e.metaKey ? 'Meta' : null, e.shiftKey ? 'Shift' : null, !e.code.match(/Alt|Shift|Control|Meta/) ? e.code : null].filter(Boolean).join('+');
    var element = document.querySelector("[data-trimmings-hotkey~=\"".concat(identifier, "\"]"));

    if (element) {
      element.click();
    }
  });
};